function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  font-size: ", "px;\n  font-family: ", ";\n  color: ", ";\n  margin: 0;\n  padding: 0;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { css } from 'styled-components';
export { default as LineHeights } from './generated/line-heights';
export var fontFamily = "\n  DD-TTNorms,\n  -apple-system,\n  BlinkMacSystemFont,\n  \"Segoe UI\",\n  Roboto,\n  Helvetica,\n  Arial,\n  sans-serif,\n  \"Apple Color Emoji\",\n  \"Segoe UI Emoji\",\n  \"Segoe UI Symbol\"\n";
export var themedFontFamily = function themedFontFamily() {
  var primaryFont = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'DD-TTNorms';
  return "\n  ".concat(primaryFont, ",\n  -apple-system,\n  BlinkMacSystemFont,\n  \"Segoe UI\",\n  Roboto,\n  Helvetica,\n  Arial,\n  sans-serif,\n  \"Apple Color Emoji\",\n  \"Segoe UI Emoji\",\n  \"Segoe UI Symbol\"\n");
};
export var baseStyles = css(_templateObject(), function (props) {
  return props.size;
}, function (props) {
  return themedFontFamily(props.themeFontFamily);
}, function (props) {
  return props.color;
});
export var DisplayModes = {
  Inline: 'inline',
  InlineBlock: 'inline-block',
  Block: 'block',
  Flex: 'flex'
};
export var FontFamilies = {
  SansSerif: 'SansSerif',
  Serif: 'Serif'
};
export var TextWeights = {
  Thin: 'Thin',
  Light: 'Light',
  Regular: 'Regular',
  Medium: 'Medium',
  Bold: 'Bold',
  ExtraBold: 'ExtraBold'
};
export var Weights = {
  Thin: '200',
  Light: '300',
  Regular: '400',
  Medium: '500',
  Bold: '700',
  ExtraBold: '800' // TODO: this is an interim change to support Caviar MFP requirements and impending deadline.
  // Come back and rethink the font weight strategy across `Text` and the entire project

};
export var CaviarWeights = {
  Thin: '100',
  Light: '100',
  Regular: '300',
  Medium: '400',
  Bold: '500',
  ExtraBold: '700'
};
export var Sizes = {
  S10: 10,
  S12: 12,
  S14: 14,
  S16: 16,
  S18: 18,
  S24: 24,
  S32: 32,
  S40: 40
};
export var LetterSpacings = {
  Tight: -0.2 / 5,
  Normal: 0,
  Wide: 0.5 / 5
};
export var TextTransforms = {
  Normal: 'none',
  UpperCase: 'uppercase'
};
export var TextAlignments = {
  Left: 'left',
  Center: 'center',
  Right: 'right',
  Justify: 'justify'
};
export var Overflows = {
  Truncate: 'truncate',
  BreakWord: 'break-word',
  Wrap: 'normal'
};